import React from "react";
import styles from "@/components/QuestionAnswers/questionAnswers.module.scss";

interface QAPropsInterface {
  id: number;
  Question: string;
  Answer: any;
}

const QuestionAnswers: React.FC<any> = (props: { qaList: QAPropsInterface[] }) => {
  const { qaList } = props;

  return (
    <>
      {qaList?.map((qa: QAPropsInterface, index: number) => (
        <div key={index}>
          {qa?.Question && <h3 className={styles.title} dangerouslySetInnerHTML={{ __html: qa?.Question }} />}
          {qa?.Answer && <p dangerouslySetInnerHTML={{ __html: qa?.Answer }} className={styles.subTitle} />}
        </div>
      ))}
    </>
  );
};

export default QuestionAnswers;
